import MDBox from "components/MDBox";
import Fieldset from "layouts/views/components/Fieldset";

import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { FormTitle, Text } from "ui-components/Form";

import { useState } from "react";

import { getModuleList } from "services/data.internal.service";
import TreeViewCheckbox from "./TreeViewCheckbox";

function TeamRoleInfo(props) {
  const {
    formRender,
    control,
    errors,
    setValue,
    watch,
    expanded,
    setExpanded,
    mode="ADD"
  } = props;

  const [modules, setModules] = useState([]);

  useQuery({
    queryKey: ["module=list"],
    queryFn: () => getModuleList("Web"),
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const mod = data.data.data;
      setModules(mod);
    },
  });

  const [permission] = watch(["permission"]);

  function renderFn(property, index, length) {
    const { xs, disabled, edit, editable, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
      ...(mode === "EDIT" && editable === false && { disabled: true,type:"text" }),
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "select") {
      if (data.multiple) {
        if (data.name === "permission") {
          renderField = (
            <Fieldset label={data.label}>
              {modules.length>0 && (
                <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TreeViewCheckbox
                    permissions={modules}
                    permissionsChecked={permission}
                    setPermissionsChecked={setValue}
                    expanded={expanded}
                    setExpanded={setExpanded}
                  />
                </Grid>
              </Grid>
              )}
            </Fieldset>
          );
        }
      }
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <FormTitle title={mode==="EDIT"?"Edit Team Role": "Add Team Role"} />

      <MDBox mt={1.625}>
        {formRender.map((renders, i) => {
          return (
            <Grid container spacing={3} key={i}>
              {renders.map((render, index) => renderFn(render, index, renders.length))}
            </Grid>
          );
        })}
      </MDBox>
    </MDBox>
  );
}

export default TeamRoleInfo;
